export const chatData = [
  {
    key:"1",
    From_Img: "user-01.jpg",
    From: "Aaryian Jose",
    To: "Charles Sellars",
    To_Img: "user-11.jpg",
    Total_Chat_Count: "105",
  },
  {
    key:"2",
    From_Img: "user-02.jpg",
    From: "Sarika Jain",
    To_Img: "user-12.jpg",
    To: "Richard Ohare",
    Total_Chat_Count: "120",
  },
  {
    key:"3",
    From_Img: "user-03.jpg",
    From: "Clyde Smith",
    To_Img: "user-13.jpg",
    To: "Judy Mercer",
    Total_Chat_Count: "200",
  },
  {
    key:"4",
    From_Img: "user-04.jpg",
    From: "Carla Jenkins",
    To_Img: "user-14.jpg",
    To: "Michael Howard",
    Total_Chat_Count: "250",
  },
  {
    key:"5",
    From_Img: "user-05.jpg",
    From: "Federico Wells",
    To_Img: "user-15.jpg",
    To: "Gilbert Humphrey",
    Total_Chat_Count: "300",
  },
  {
    key:"6",
    From_Img: "user-06.jpg",
    From: "Edward Lietz",
    To_Img: "user-16.jpg",
    To: "Christopher Hurt",
    Total_Chat_Count: "180",
  },
  {
    key:"7",
    From_Img: "user-07.jpg",
    From: "Sharon Ford",
    To_Img: "user-17.jpg",
    To: "Chasity Williams",
    Total_Chat_Count: "200",
  },
  {
    key:"8",
    From_Img: "user-08.jpg",
    From: "Thomas Rethman",
    To_Img: "user-18.jpg",
    To: "Harry Newton",
    Total_Chat_Count: "320",
  },
  {
    key:"9",
    From_Img: "user-09.jpg",
    From: "Wilbur Martinez",
    To_Img: "user-19.jpg",
    To: "John Gonzalez",
    Total_Chat_Count: "400",
  },
  {
    key:"10",
    From_Img: "user-10.jpg",
    From: "Danielle Baker",
    To_Img: "user-20.jpg",
    To: "Pearl Dewitt",
    Total_Chat_Count: "210",
  },
];